import { TitleH3 } from "components/generic";
import styled from "styled-components/macro";

export const TenantsCard = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  & > img {
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
  & > div:last-child {
    grid-area: 2 / 2 / auto / auto;
    display: inline-grid;
    gap: 24px;
    grid-template-columns: max-content max-content;
    @media ${(props) => props.theme.media.phone} {
      grid-area: auto;
      grid-template-columns: 1fr;
    }
  }
  & > div {
    margin-left: 40px;
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    & > div {
      margin: 24px 0 0 0;
    }
  }
`;

export const RemoveTenant = styled(TitleH3)`
  color: ${(props) => props.theme.colors.thirdly};
  cursor: pointer;
`;
